import React from 'react';
import { ArrowLinkButton, Button, ButtonWrap } from '../../../ui';
import {
	Dialog,
	DialogHeader,
	DialogHeaderGradient,
	DialogMain,
} from '../../shared/components/dialog';
import { HashDialog } from '../../shared/components/dialog/HashDialog';

const DialogWithButton = () => {
	const [showDialog, setShowDialog] = React.useState(false);
	const open = () => setShowDialog(true);
	const close = () => setShowDialog(false);

	return (
		<>
			<Button onClick={open}>Open dialog</Button>
			{showDialog && (
				<Dialog onClose={close} ariaLabel="some dialog">
					<DialogHeader title="Some dialog header" />
					<DialogMain>
						<p>
							Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eos
							assumenda sed, nisi, nemo veritatis consequuntur odit architecto
							aspernatur facere omnis quibusdam eum eveniet nulla cum mollitia
							culpa magnam repudiandae veniam.
						</p>
					</DialogMain>
				</Dialog>
			)}
		</>
	);
};

const DialogWithButtonAndGradientHeader = () => {
	const [showDialog, setShowDialog] = React.useState(false);
	const open = () => setShowDialog(true);
	const close = () => setShowDialog(false);

	return (
		<>
			<Button onClick={open}>
				Open dialog with gradient background header
			</Button>
			{showDialog && (
				<Dialog onClose={close} ariaLabel="some dialog">
					<DialogHeaderGradient title="Some other dialog header" />
					<DialogMain>
						<p>
							Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eos
							assumenda sed, nisi, nemo veritatis consequuntur odit architecto
							aspernatur facere omnis quibusdam eum eveniet nulla cum mollitia
							culpa magnam repudiandae veniam.
						</p>
					</DialogMain>
				</Dialog>
			)}
		</>
	);
};

const DialogWithLink = () => (
	<>
		<ArrowLinkButton secondary href="#another-dialog">
			Open dialog with link
		</ArrowLinkButton>
		<HashDialog hash="#another-dialog" ariaLabel="some dialog">
			<DialogHeaderGradient title="Another header" />
			<DialogMain>
				<p>
					Lorem ipsum dolor sit amet consectetur, adipisicing elit. Porro nam
					ratione nesciunt minima alias ea pariatur enim expedita ipsam
					necessitatibus omnis deleniti tempore, dolores, temporibus, deserunt
					modi eius eveniet velit!
				</p>
			</DialogMain>
		</HashDialog>
	</>
);

export const Dialogs = () => (
	<>
		<h2 id="dialog">Dialogs</h2>
		<ButtonWrap>
			<DialogWithButton />
			<DialogWithButtonAndGradientHeader />
			<DialogWithLink />
		</ButtonWrap>
	</>
);
